const actions = {
  CREATE_REQUEST: "RAKUTEN_SCORING_SETTING/CREATE_REQUEST",
  CREATE_SUCCESS: "RAKUTEN_SCORING_SETTING/CREATE_SUCCESS",
  CREATE_ERROR: "RAKUTEN_SCORING_SETTING/CREATE_ERROR",
  GET_DETAIL_REQUEST: "RAKUTEN_SCORING_SETTING/GET_DETAIL_REQUEST",
  GET_DETAIL_SUCCESS: "RAKUTEN_SCORING_SETTING/GET_DETAIL_SUCCESS",
  GET_DETAIL_ERROR: "RAKUTEN_SCORING_SETTING/GET_DETAIL_ERROR",
  UPDATE_REQUEST: "RAKUTEN_SCORING_SETTING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "RAKUTEN_SCORING_SETTING/UPDATE_SUCCESS",
  UPDATE_ERROR: "RAKUTEN_SCORING_SETTING/UPDATE_ERROR",
  EXECUTE_REQUEST: "RAKUTEN_SCORING_SETTING/EXECUTE_REQUEST",
  EXECUTE_SUCCESS: "RAKUTEN_SCORING_SETTING/EXECUTE_SUCCESS",
  EXECUTE_ERROR: "RAKUTEN_SCORING_SETTING/EXECUTE_ERROR",
  CANCEL_REQUEST: "RAKUTEN_SCORING_SETTING/CANCEL_REQUEST",
  CANCEL_SUCCESS: "RAKUTEN_SCORING_SETTING/CANCEL_SUCCESS",
  CANCEL_ERROR: "RAKUTEN_SCORING_SETTING/CANCEL_ERROR",
  CURRENT_REQUEST: "RAKUTEN_SCORING_SETTING/CURRENT_REQUEST",
  CURRENT_SUCCESS: "RAKUTEN_SCORING_SETTING/CURRENT_SUCCESS",
  CURRENT_ERROR: "RAKUTEN_SCORING_SETTING/CURRENT_ERROR",
  HISTORIES_REQUEST: "RAKUTEN_SCORING_SETTING/HISTORIES_REQUEST",
  HISTORIES_SUCCESS: "RAKUTEN_SCORING_SETTING/HISTORIES_SUCCESS",
  HISTORIES_ERROR: "RAKUTEN_SCORING_SETTING/HISTORIES_ERROR",
  SEARCH_REQUEST: "RAKUTEN_SCORING_SETTING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "RAKUTEN_SCORING_SETTING/SEARCH_SUCCESS",
  SEARCH_ERROR: "RAKUTEN_SCORING_SETTING/SEARCH_ERROR",
  DELETE_REQUEST: "RAKUTEN_SCORING_SETTING/DELETE_REQUEST",
  DELETE_SUCCESS: "RAKUTEN_SCORING_SETTING/DELETE_SUCCESS",
  DELETE_ERROR: "RAKUTEN_SCORING_SETTING/DELETE_ERROR",
  UPLOAD_TO_S3_REQUEST: "RAKUTEN_SCORING_SETTING/UPLOAD_TO_S3_REQUEST",
  UPLOAD_TO_S3_SUCCESS: "RAKUTEN_SCORING_SETTING/UPLOAD_TO_S3_SUCCESS",
  UPLOAD_TO_S3_ERROR: "RAKUTEN_SCORING_SETTING/UPLOAD_TO_S3_ERROR",

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),
  getDetail: (payload) => ({
    type: actions.GET_DETAIL_REQUEST,
    payload,
  }),
  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),
  execute: (payload) => ({
    type: actions.EXECUTE_REQUEST,
    payload,
  }),
  cancel: (payload) => ({
    type: actions.CANCEL_REQUEST,
    payload,
  }),
  getCurrent: (payload) => ({
    type: actions.CURRENT_REQUEST,
    payload,
  }),
  getHistories: (payload) => ({
    type: actions.HISTORIES_REQUEST,
    payload,
  }),
  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),
  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),
  uploadToS3: (payload) => ({
    type: actions.UPLOAD_TO_S3_REQUEST,
    payload,
  }),
};

export default actions;
